import { useSetAtom } from 'jotai';
import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router';
import { locationsUrlParamsAtom } from 'src/atoms/filters/locations';
import { useAuth } from 'src/auth/hooks/useAuth';
import { useIsCslUser } from 'src/auth/hooks/useIsCslUser';
import { useFilterToUrlParser } from 'src/common/components/Filters/hooks/useFilterToUrlParser';

export const LocationsURLParser = ({ children }: { children: React.ReactElement }) => {
  const [searchParams] = useSearchParams();

  const { user } = useAuth();
  const isCslUser = useIsCslUser();

  const setURLParams = useSetAtom(locationsUrlParamsAtom);
  const isMounted = useRef(false);

  useEffect(() => {
    if (!isCslUser) {
      if (searchParams.get('account') !== user.referenceId) {
        searchParams.set('account', user.referenceId);
        setURLParams(searchParams);
      }
    }
  }, [isCslUser, user.referenceId]);

  useFilterToUrlParser(
    {
      urlSearchParamsAtom: locationsUrlParamsAtom,
    },
    isMounted.current,
  );

  if (!isMounted.current) {
    setURLParams(searchParams);
    isMounted.current = true;
  }

  return <>{children}</>;
};
